import { useSelectedComputeCellNodes } from "~/state";

import { useEasel } from "../easel";

export const useEaselSelectedComputeCellNodes = () => {
	const { documentId, pageId } = useEasel();

	return useSelectedComputeCellNodes(documentId, pageId);
};
